import { defineKey as T } from '@ha/intl';

export function getResponseTimeString(responseTime: number) {
  const hours = responseTime / (60 * 60);

  if (hours <= 1) {
    return T('within an hour');
  }

  if (hours <= 12) {
    return T('within few hours');
  }

  if (hours <= 24) {
    return T('within a day');
  }

  const days = hours / 24;

  if (days <= 3) {
    return T('within 3 days');
  }

  if (days <= 7) {
    return T('within a week');
  }

  return T('more than a week');
}
